<template>
  <span v-if="value">
    <template v-if="value.toLowerCase() == 'updating'">
      <img src="/img/Spinner-1s-30px.gif" />
    </template>
    <template v-else>
      <span :title="'Dehumidifier: ' + value">
        <v-icon
          v-if="!disabled"
          :size="iconSize"
          :color="dehumstateColors[value.toLowerCase()]"
        >
          $vuetify.icons.dehumidifier
        </v-icon>
        <v-icon
          v-else
          :size="iconSize"
          color="rgb(192, 192, 192)"
        >
          $vuetify.icons.dehumidifier
        </v-icon>
      </span>
    </template>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "iconSize", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {
      dehumstateColors: {
        off: "grey",
        on: "orange"
      }
    };
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
